import type { FormMethodsLike } from "./setup-form-field-watcher";

export function ensurePrimaryNotInSecondary(
  formMethods: FormMethodsLike,
  primaryFieldName: string,
  secondaryFieldName: string
): void {
  const primary = formMethods.getValues?.(primaryFieldName) as
    | string
    | undefined;
  const secondary = formMethods.getValues?.(secondaryFieldName) as
    | string[]
    | undefined;

  if (!primary || !Array.isArray(secondary) || !secondary.includes(primary)) {
    return;
  }

  formMethods.setValue?.(
    secondaryFieldName,
    secondary.filter((channelId) => channelId !== primary)
  );
}
